import { createFileRoute } from "@tanstack/react-router"

import CreateUserForm from "@/admin/create-user/create-user-form"

export const Route = createFileRoute("/_admin/admin/create-user")({
  component: CreateUserPage,
})

function CreateUserPage() {
  return (
    <div className="space-y-4 p-4">
      <CreateUserForm />
    </div>
  )
}
